import { useState, useEffect } from 'react';
import Convert from './Convert';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import WordCloud from '../wordcloud/wordcloud';

const options = [
			{
				label: 'Zulu',
				value: 'zu'
			}, 
			{
				label: 'Afrikaans',
				value: 'af'
			}, {
				label: 'English',
				value: 'en'
			}
];
const Translate = () => {
	const [language, setLanguage] = useState('zu');
	const [text, setText] = useState('');
	const [recording, isRecording] = useState(false);
	const { transcript } = useSpeechRecognition();
	const [timerID, setID ] = useState(null);
	const [textArray, setTextArray] = useState(['','Goals','','','New','','','Challenge','','','Truth','','','Determination','','','Laughter','','','Perseverance','','','Faithful','','','Endurance','','','Tragedy','','','Learning','','','Anticipation','','','Courage','','','Hope','','','Time','','','Brain','','','Attention','']);
	const [showStuff, setShowStuff] = useState(false);

	const handleWords = () => {
		if (textArray === undefined) {
			return setTextArray([text])
		}
		return setTextArray([...textArray, text])
	}

	useEffect(() => {
		clearInterval(timerID);
		setText(transcript);
	 }, [transcript]);

	 useEffect(() => {
		const id = setTimeout(() => {
			isRecording(false);
		}, 3000);
		setID(id);
	 }, [text]);

	if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
		return (
			<h1 style={{margin: '1em auto', color: '#fafafa', textAlign: 'left'}}>Not supported on this browser/ device. We are working hard to ensure that all devices and browsers are catered for, the application is in early stages of development and will have more support in due time. </h1>
		);
	}

	const onMicClick = (e) => {
		e.preventDefault();

		if(!recording) { 
			isRecording(true);
			SpeechRecognition.startListening();
		} else {
			SpeechRecognition.stopListening();
			isRecording(false);
		}
	}
	

	
	return (
		<div className="w-full flex flex-col justify-center p-6">
			<div className='w-full flex flex-col justify-center items-center text-white'>
                <h1 className='text-lg font-bold text-center' >Speech To Text And Translation</h1>

            </div>
		
			{showStuff &&
			<div className="card-compact lg:card-normal justify-center center-text ">
				<div className="card-body items-center text-center w-full">
					<div className="h-8 " />
					<div className="form-control justify-center text-center ">
						<label className="label ">
							<span className="label-text-alt text-white text-center">Click the microphone to record or enter text here.</span>
						</label>
						<input 
							placeholder="Eg. hello, how are you" 
							value={text} 
							onChange={(e) => setText(e.target.value)} 
							className="w-full input input-primary"
						/>
					</div>
					<div className="h-4" />
					{/* <p className="label-text-alt">Select a language</p> */}
					<div className="form-control w-full mb-5">
						<label className="label">
							<span className="label-text-alt text-white">Select a language</span>
						</label> 
						<select  className="select select-bordered select-primary w-full" value={language} onChange={e => setLanguage(e.target.value)}>
							<option>Select language</option> 
							{options.map(o => (
								<option value={o.value}>{o.label}</option> 
							))}
						</select>
					</div>
					<div className="h-4" />
					<Convert 
						text={text} 
						language={language} 
					/>
					<div className='flex flex-1 justify-center items-center'>
						{
							recording 
							?<button
								onClick={(e) => onMicClick(e)}
								className="overflow-visible rounded-full bg-primary shadow-xl p-4 border-2 border-white border-solid m-4"
								id="mic"
							>
								<svg xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" style={{ fill: 'white', height: '30px', width: '30px'}} textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" viewBox="0 0 419 512.5"><path fillRule="nonzero" d="M302.29 90.86v137.26c0 5.01-.32 9.78-.89 14.36L143.48 54.63c29.13-83.38 158.81-71.32 158.81 36.23zM6.28 58.21c-9.51-11.31-8.05-28.19 3.26-37.7 11.31-9.51 28.19-8.05 37.7 3.26l90.46 107.6v-.45l138.05 164.22-.21.19 40.39 48.05.21-.2 26.35 31.34-.21.2 70.44 83.79c9.51 11.31 8.05 28.2-3.26 37.71-11.31 9.51-28.19 8.05-37.7-3.26l-73.73-87.71-3.25 1.55a177.508 177.508 0 0 1-54.36 15.29v69.98c0 5.63-2.3 10.75-5.99 14.44a20.394 20.394 0 0 1-14.44 5.99c-5.63 0-10.74-2.3-14.43-5.99a20.394 20.394 0 0 1-5.99-14.44v-69.98a176.994 176.994 0 0 1-54.33-15.31c-19.31-8.94-36.77-21.22-51.61-36.06l-.35-.38c-16.37-16.45-29.58-36.04-38.61-57.73a177.451 177.451 0 0 1-13.61-68.25c0-5.6 2.3-10.72 6-14.42 3.68-3.7 8.79-6 14.42-6 5.64 0 10.75 2.3 14.44 5.99l.41.45c3.46 3.65 5.58 8.59 5.58 13.98 0 18.62 3.74 36.4 10.49 52.62 7.03 16.89 17.33 32.13 30.09 44.89 12.78 12.76 28.02 23.08 44.88 30.09a136.933 136.933 0 0 0 52.62 10.49c17.89 0 35.01-3.45 50.71-9.71l-47.35-56.32c-42.23 1.66-85.65-27.78-85.65-88.3v-13.59L6.28 58.21zm341.19 239.07.12-.3c6.75-16.22 10.49-34 10.49-52.62 0-5.63 2.3-10.75 5.99-14.44 3.69-3.69 8.8-5.98 14.43-5.98 5.63 0 10.75 2.29 14.44 5.98l.41.45c3.45 3.66 5.58 8.59 5.58 13.99a177.694 177.694 0 0 1-22.75 87.08l-28.71-34.16z"/></svg>
							</button>

							:<button
								onClick={(e) => onMicClick(e)}
								className="overflow-visible rounded-full bg-primary shadow-xl p-4 border-2 border-white border-solid m-4"
								id="mic"
							>
								<svg xmlns="http://www.w3.org/2000/svg" style={{ fill: 'white', height: '30px', width: '30px'}} id="Layer_1" data-name="Layer 1" viewBox="0 0 82.05 122.88"><path d="M59.89,20.83V52.3c0,27-37.73,27-37.73,0V20.83c0-27.77,37.73-27.77,37.73,0Zm-14.18,76V118.2a4.69,4.69,0,0,1-9.37,0V96.78a40.71,40.71,0,0,1-12.45-3.51A41.63,41.63,0,0,1,12.05,85L12,84.91A41.31,41.31,0,0,1,3.12,71.68,40.73,40.73,0,0,1,0,56a4.67,4.67,0,0,1,8-3.31l.1.1A4.68,4.68,0,0,1,9.37,56a31.27,31.27,0,0,0,2.4,12.06A32,32,0,0,0,29,85.28a31.41,31.41,0,0,0,24.13,0,31.89,31.89,0,0,0,10.29-6.9l.08-.07a32,32,0,0,0,6.82-10.22A31.27,31.27,0,0,0,72.68,56a4.69,4.69,0,0,1,9.37,0,40.65,40.65,0,0,1-3.12,15.65A41.45,41.45,0,0,1,70,85l-.09.08a41.34,41.34,0,0,1-11.75,8.18,40.86,40.86,0,0,1-12.46,3.51Z"/></svg>
							</button>
						}
						<button className='rounded-full bg-primary shadow-xl p-4 border-2 border-white border-solid m-4' onClick={handleWords}>
							<svg xmlns="http://www.w3.org/2000/svg" style={{ fill: 'white', height: '30px', width: '30px' }} shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" viewBox="0 0 512 425.29"><path d="M256 196c63.31 0 114.65 51.33 114.65 114.65 0 63.32-51.34 114.64-114.65 114.64-63.32 0-114.65-51.32-114.65-114.64S192.68 196 256 196zm103.79-71.3c-3.13 1.55-6.3 3.25-9.42 5.05-9.37 5.49-18.63 12.21-28.08 19.92l-20.17-23.09c6.96-6.45 14.5-12.33 22.5-17.53 6.37-4.17 13.04-7.88 19.92-11.05 2.75-1.38 5.5-2.67 8.33-3.87-13.29-23.55-32.42-40.42-54.09-50.83-43.06-20.62-96.68-16.14-134.61 13.32-21.79 16.88-38.33 42.13-44.71 75.59l-2 10.45-10.42 1.84c-10.21 1.79-19.32 4.25-27.33 7.37-7.75 3.01-14.66 6.72-20.7 11.09-4.84 3.5-9.01 7.42-12.54 11.66-10.97 13.13-16.05 29.58-15.93 46.26.13 16.9 5.63 33.99 15.8 48.03 3.79 5.21 8.16 10.01 13.16 14.17 5.09 4.2 10.79 7.7 17.21 10.34 6.37 2.62 13.42 4.49 21.21 5.58h11.34c-.31 3.84-.46 7.73-.46 11.64 0 6.45.41 12.8 1.22 19.02h-12.6l-1.92-.16c-11.12-1.42-21.21-4.05-30.37-7.83-9.46-3.93-17.84-8.97-25.21-15.13-7-5.84-13.12-12.46-18.33-19.67C7.67 267.71.17 244.29 0 220.95c-.16-23.58 7.17-47.03 23.01-66.04 5.12-6.16 11.15-11.83 18.07-16.83 8.05-5.83 17.25-10.75 27.68-14.78 7.16-2.8 14.82-5.14 22.91-7.01 9.17-36.41 28.71-64.45 53.83-83.92C192.57-4.1 258.61-9.92 312.04 15.75c29.2 14.05 54.7 37.42 71.25 70.29 6.66-1.04 13.33-1.58 19.95-1.5 69.26.52 109.46 59.53 108.75 124.04-.29 26.29-7.37 52.46-21.88 71.71-9.45 12.54-21.58 22.79-36.12 30.91-13.99 7.84-30.33 13.8-48.66 18.05l-3.34.4a148.914 148.914 0 0 0 .7-31.27c13.69-3.49 25.85-8.07 36.26-13.88 10.96-6.13 19.92-13.59 26.62-22.54 10.42-13.88 15.55-33.5 15.75-53.63.57-47.22-26.49-92.88-78.29-93.2-14.29-.13-29.16 3.33-43.24 9.57zm-56.22 178.56c3.65.15 6.24 1.36 7.73 3.64 4.06 6.08-1.47 12.09-5.32 16.33-10.91 11.96-37.64 40.73-43.02 47.06-4.07 4.51-9.89 4.51-13.96 0-5.56-6.49-33.63-36.57-44-48.21-3.6-4.05-8.05-9.57-4.3-15.18 1.53-2.28 4.09-3.49 7.74-3.64h22.14v-32.17c0-5.84 4.78-10.64 10.64-10.64h29.56c5.85 0 10.65 4.79 10.65 10.64v32.17h22.14z"/></svg>
						</button>
					</div>
					<div className='h-96 text-center'>
						{textArray &&<WordCloud wordArray={textArray}/>}
					</div>	
					
				</div>
			</div> 

			}
			{!showStuff && 
				<div className="flex justify-center items-center">
					<div className="w-full flex flex-col justify-center items-center text-white">
					<p className="mb-6">Press the button below to start the speech to text process or upload to the word cloud below.</p>
					<button className="text-white outline outline-white outline-2 p-2" onClick={() => setShowStuff(true)}>
						CLICK ME
					</button>
					</div>
				</div>
			}
	</div>
	);
};

export default Translate;